import { render, staticRenderFns } from "./claimInsuranceHis.vue?vue&type=template&id=28fec0bc&scoped=true&"
import script from "./claimInsuranceHis.vue?vue&type=script&lang=js&"
export * from "./claimInsuranceHis.vue?vue&type=script&lang=js&"
import style0 from "./claimInsuranceHis.vue?vue&type=style&index=0&id=28fec0bc&prod&scoped=true&lang=css&"
import style1 from "./claimInsuranceHis.vue?vue&type=style&index=1&id=28fec0bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fec0bc",
  null
  
)

export default component.exports